<script>
  import { site } from './store.js'
  import Division from './Division.svelte'

  $: opened = $site.division.list.find(d => d.open)

</script>

<div class="our-divisions">
  {#if window.location.host.includes('sunvairgroup')}
     <div class="inner">
       <h2 class="wow fadeInLeft" data-wow-delay=".25s" style="visibility: visible; animation-delay: 0.25s; animation-name: fadeInLeft;">OUR DIVISIONS</h2>
    </div>
  {:else}
    <div class="inner">
      <div class="sub-title wow fadeInLeft" style="visibility: visible; animation-name: fadeInLeft;">A MEMBER OF</div>
      <div class="fr fss" style="margin-top:60px;">Learn more about <a href="https://www.sunvairgroup.com">Sunvair Aerospace Group</a></div>
      <h3 class="wow fadeInLeft" data-wow-delay=".25s" style="visibility: visible; animation-delay: 0.25s; animation-name: fadeInLeft; margin: 10px 0px 20px;"><a href="https://www.sunvairgroup.com"><img src="/img/sunvairgroup/logo.svg" alt="Sunvair Aerospace Group" style="width: 25%; min-width: 120px;"></a></h3>
    </div>
  {/if}
  <div class="focus-panels" class:opened style="background-image: url({ $site.division.background });">
    {#each $site.division.list as division, index}
      <Division {...division} {index} />
    {/each}
  </div>
</div>

<style>
  .focus-panels{
    display: flex;
    flex-wrap: nowrap;
    align-content: stretch;
    height: 60rem;
    background-size: cover;
    background-position: 50% 50%;
    overflow: hidden;
    background-attachment: fixed;
  }
  .opened{
    
  }
</style>

